import { reportCarburetionTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_CARBURETION, SET_REPORT_CARBURETION_FILTERS, RESTORE_INITIAL } = reportCarburetionTypes;

const initialState = {
  ReportCarburetion: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportCarburetionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_CARBURETION:
      return { ...state, ReportCarburetion: payload };
    case SET_REPORT_CARBURETION_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
